// import axios from "axios";

export default {
    state: () => ({
        product: {},
        isModalVisible: false,
    }),
    getters: {},
    mutations: {
        setProduct(state, product) {
            state.product = product;
        },
        setIsModalVisible(state, isModalVisible) {
            state.isModalVisible = isModalVisible;
        },
    },
    actions: {
        toggleIsModalVisible({state, commit}) {
            if (state.isModalVisible) {
                document.body.classList.remove("body-scroll-hidden");
            } else {
                document.body.classList.add("body-scroll-hidden");
            }
            commit("setIsModalVisible", !state.isModalVisible);
        },
    },
    namespaced: true,
};
